import { MemberDTO } from '../../types';

const roleOrder = [
  'Master Admin',
  'Admin',
  'Project Lead',
  'Internal Manager',
  'Internal Staff',
  'Guest Manager',
  'Guest',
];

function getRoleGroup(title: string) {
  if (title === 'Master Admin' || title === 'Admin') return 'Master Admin/Admin';
  if (title === 'Project Lead') return 'Project Lead';
  if (title === 'Internal Manager') return 'Internal Manager';
  if (title === 'Internal Staff') return 'Internal Staff';
  if (title === 'Guest Manager') return 'Guest Manager';
  if (title === 'Guest') return 'Guest';
  return title;
}

export function useSortedGroupedMembers(members: MemberDTO[] = []) {
  // Group members
  const grouped: Record<string, MemberDTO[]> = {};
  members.forEach((m) => {
    const group = getRoleGroup(m.title);
    if (!grouped[group]) grouped[group] = [];
    grouped[group].push(m);
  });
  // Sort each group by name ascending
  Object.keys(grouped).forEach((group) => {
    grouped[group].sort((a, b) => {
      const nameA = (a['first-name'] + ' ' + a['last-name']).toLowerCase();
      const nameB = (b['first-name'] + ' ' + b['last-name']).toLowerCase();
      return nameA.localeCompare(nameB);
    });
  });
  // Flatten sorted groups in order
  const sortedMembers: MemberDTO[] = [];
  for (const role of roleOrder) {
    const group = role === 'Master Admin' ? 'Master Admin/Admin' : role;
    if (grouped[group]) {
      sortedMembers.push(...grouped[group]);
    }
  }
  return sortedMembers;
}
